import { API_CONFIG } from '../config';
import { normalizeCsAdminRole } from './csAdminRoles';

/**
 * Separate storage per portal so /companysecretary and /groupcompanysecretary on the same
 * origin do not share sessions when users switch URL paths.
 */
export const CS_PORTAL_AUTH_STORAGE = {
  token: 'cs_portal_token',
  refreshToken: 'cs_portal_refreshToken',
  user: 'cs_portal_user',
};

export const CSADMIN_AUTH_STORAGE = {
  token: 'csadmin_token',
  refreshToken: 'csadmin_refreshToken',
  user: 'csadmin_user',
};

const LEGACY_KEYS = ['token', 'refreshToken', 'user'];

const ALL_STORAGE_KEYS = [
  ...Object.values(CS_PORTAL_AUTH_STORAGE),
  ...Object.values(CSADMIN_AUTH_STORAGE),
  ...LEGACY_KEYS,
];

export function getAuthStorageForPortalMode(portalMode = API_CONFIG.PORTAL_MODE) {
  return portalMode === 'cs' ? CS_PORTAL_AUTH_STORAGE : CSADMIN_AUTH_STORAGE;
}

export function getActiveAuthStorage() {
  return getAuthStorageForPortalMode(API_CONFIG.PORTAL_MODE);
}

function storageForRole(role) {
  const normalized = normalizeCsAdminRole(role);
  if (normalized === 'COMPANY_SECRETARY') return CS_PORTAL_AUTH_STORAGE;
  if (normalized === 'IT_ADMIN' || normalized === 'GROUP_SECRETARY') return CSADMIN_AUTH_STORAGE;
  return getActiveAuthStorage();
}

/** One-time migration from pre-split shared csadmin_* keys */
export function migrateLegacyAuthStorage() {
  if (typeof window === 'undefined') return;

  const active = getActiveAuthStorage();
  if (localStorage.getItem(active.token)) return;

  const legacyToken =
    localStorage.getItem('csadmin_token')
    || localStorage.getItem('token');
  const legacyUser =
    localStorage.getItem('csadmin_user')
    || localStorage.getItem('user');
  if (!legacyToken || !legacyUser) return;

  try {
    const parsed = JSON.parse(legacyUser);
    const role = normalizeCsAdminRole(parsed?.role);
    const target = storageForRole(role);
    if (target !== active) return;

    localStorage.setItem(target.token, legacyToken);
    const legacyRefresh =
      localStorage.getItem('csadmin_refreshToken')
      || localStorage.getItem('refreshToken');
    if (legacyRefresh) {
      localStorage.setItem(target.refreshToken, legacyRefresh);
    }
    localStorage.setItem(target.user, legacyUser);
  } catch (_) {
    // ignore invalid JSON
  }
}

export function clearCsadminAuthStorage() {
  ALL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
